import { render, staticRenderFns } from "./FileTransferUpload.vue?vue&type=template&id=0b5bf3b9&scoped=true&"
import script from "./FileTransferUpload.vue?vue&type=script&lang=js&"
export * from "./FileTransferUpload.vue?vue&type=script&lang=js&"
import style0 from "./FileTransferUpload.vue?vue&type=style&index=0&id=0b5bf3b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5bf3b9",
  null
  
)

export default component.exports